import React, { useEffect, useState } from 'react';
import { fetchAllCities } from 'services';
import { showError } from 'utils';

const CityDropdown = props => {
  const [loading, setLoading] = useState<boolean>(true);
  const [cities, setCities] = useState<string[]>([]);
  const {
    value,
    disabled,
    onChange,
  } = props;
  
  const fetchCitiesFn = async () => {
    try {
      const response = await fetchAllCities();
      setCities(response);
    } catch(e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCitiesFn();
  }, []);
  
  return (
    <select
      value={value}
      disabled={disabled || loading}
      onChange={e => onChange(e.target.value)}
      className={'form-control'}
    >
      <option hidden={!!value}>Select a city</option>
      {cities.map(city => (
        <option key={city} value={city}>{city}</option>
      ))}
    </select>
  );
};

export default CityDropdown;